import type { Project, Run } from "@/types/chemistry";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CompoundInfoTab } from "./CompoundInfoTab";
import { RunsTab } from "./RunsTab";

interface ProjectSidebarProps {
  project: Project;
  runs: Run[];
  onNewRun: () => void;
}

export const ProjectSidebar = ({ project, runs, onNewRun }: ProjectSidebarProps) => {
  return (
    <div className="h-full flex flex-col border-l border-border bg-card">
      <Tabs defaultValue="compound" className="flex flex-col h-full">
        <TabsList className="w-full rounded-none border-b border-border bg-transparent h-auto p-0">
          <TabsTrigger
            value="compound"
            className="flex-1 rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none py-2 text-xs font-medium"
          >
            Synthesis
          </TabsTrigger>
          <TabsTrigger
            value="runs"
            className="flex-1 rounded-none border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none py-2 text-xs font-medium"
          >
            Runs {runs.length > 0 && <span className="ml-1 text-muted-foreground">({runs.length})</span>}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="compound" className="flex-1 mt-0 overflow-auto">
          <CompoundInfoTab project={project} />
        </TabsContent>

        <TabsContent value="runs" className="flex-1 mt-0 overflow-hidden">
          <RunsTab projectId={project.id} runs={runs} onNewRun={onNewRun} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
